import NewLogoWithOmny from "@/components/brand_elements/NewLogoWithOmny.vue";
import TheWrapperPublicV2 from "@/components/TheWrapperPublicV2.vue";
import AppForm from "@/components/AppForm.vue";
import StrokedChevronLeftIcon from "@/components/icons/StrokedChevronLeftIcon.vue";
import AppButton from "@/components/AppButton.vue";
export default {
  name: "RecoverySuccess",
  components: {
    TheWrapperPublicV2,
    NewLogoWithOmny,
    AppForm,
    StrokedChevronLeftIcon,
    AppButton
  },
  props: {
    type: {
      type: String,
      default: "recovery"
    }
  },
  data() {
    return {
      titles: {
        recovery: "Reset password",
        reset: "Password reset successful",
        onboard: "Account creation successful!",
        onboard_failed: "Account creation on Primelis Market Platform failed!"
      },
      descriptions: {
        recovery: "We have sent you an email with a link to reset your password. Please check the email and follow the instructions.",
        reset: "Your password has been successfully reset. Please log in with your new password.",
        onboard: "You can now connect to the Primelis Market Platform.",
        onboard_failed: 'Please contact our <a href="mailto:support@get-omny.com" style="color: #fff">support</a>'
      },
      loginBtnText: {
        reset: "Log in",
        onboard: "Connect",
        onboard_failed: "Back to Login"
      }
    };
  },
  methods: {
    loginPage() {
      this.$router.replace("/login");
    }
  }
};